import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings, apiCredentials, snapapiCredentials } from '../storan-constant';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly AUTH_KEY = 'isAuthenticated';
  constructor(private http: HttpClient, private router:Router) { }
  
  login() {
    localStorage.setItem(this.AUTH_KEY, 'true');
  }

  logout() {
    localStorage.removeItem(this.AUTH_KEY);
    //if (!localStorage.getItem(this.AUTH_KEY)) {
    //  this.router.navigate(['/log-in']);
    //}
  }

  isAuthenticated(): boolean {
    return localStorage.getItem(this.AUTH_KEY) === 'true';
  }

  checkAuthAndRedirect() {
    if (!this.isAuthenticated()) {
      this.router.navigate(['/log-in']);
    }
  }
  checkAuthAndRedirectHome() {
    if (this.isAuthenticated()) {
      this.router.navigate(['/program']);
    }
  }
  postLoginTokenUserApi(): Observable<any> {
    return this.http.post<any>(AppSettings.postLoginToken, apiCredentials)
  }
  postLoginTokenSnapApi(): Observable<any> {
    return this.http.post<any>(AppSettings.snapLogin, snapapiCredentials)
  }
}
